module.exports = __webpack_public_path__ + "img/Matematicas.43df9b68.png";